import React, { forwardRef, RefObject, useImperativeHandle, useRef } from 'react';
import { ScrollView, StyleProp, View, ViewStyle } from 'react-native';

import { Theme } from '@constants';

import { styles } from './styles';

export const ScrollingPageView = forwardRef<ScrollingPageView, ScrollingPageViewProps>(
  ({ style, onIndexChanged, children }, reference) => {
    const scrollReference = useRef<ScrollView>(null);

    const setPage = (index: number) => {
      scrollReference.current?.scrollTo({
        x: index * Theme.appWidth,
        y: 0,
        animated: true,
      });
      onIndexChanged?.(index);
    };

    useImperativeHandle(
      reference,
      () => ({ scrollReference, setPage }),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [scrollReference.current],
    );

    return (
      <ScrollView horizontal pagingEnabled ref={scrollReference} scrollEnabled={false} style={style}>
        <View style={styles.fullscreenPages}>{children}</View>
      </ScrollView>
    );
  },
);

type ScrollingPageViewProps = {
  style?: StyleProp<ViewStyle>;
  onIndexChanged?: (value: number) => void;
};

export type ScrollingPageView = {
  scrollReference: RefObject<ScrollView>;
  setPage: (value: number) => void;
};
